// extracted by mini-css-extract-plugin
export default {"table":"UDlF1","table__row":"Y9rN1"};